/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { Popover, useSafeContext } from '../utils/index.js';
import { ComboBoxStateContext, ComboBoxActionContext, ComboBoxRefsContext, } from './helpers.js';
export const ComboBoxDropdown = React.forwardRef((props, forwardedRef) => {
    const { children, ...rest } = props;
    const { isOpen } = useSafeContext(ComboBoxStateContext);
    const dispatch = useSafeContext(ComboBoxActionContext);
    const { inputRef, toggleButtonRef } = useSafeContext(ComboBoxRefsContext);
    // sync internal isOpen state with user's visible prop
    React.useEffect(() => {
        if (props.visible != undefined) {
            dispatch({ type: props.visible ? 'open' : 'close' });
        }
    }, [dispatch, props.visible]);
    return (React.createElement(Popover, { placement: 'bottom-start', visible: isOpen, onClickOutside: React.useCallback((_, { target }) => {
            var _a;
            if (!((_a = toggleButtonRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                dispatch({ type: 'close' });
            }
        }, [dispatch, toggleButtonRef]), animation: 'shift-away', duration: 200, reference: inputRef, ref: forwardedRef, content: children, ...rest }));
});
ComboBoxDropdown.displayName = 'ComboBoxDropdown';
